import { isDefined } from "@omni/utils/helper.utils";

export const TAG_ID = "data-tag-id";
export const TAG_ZONE_ID = "data-tag-zone-id";

type Segment = string | number | undefined | null;

const isValidSegment = (segment: Segment) => {
    if (!isDefined(segment)) return false;
    if (segment === "") return false;

    return true;
};

export type TagProps = {
    [TAG_ID]?: string;
    [TAG_ZONE_ID]?: string;
};

const getTagIdFor = (id: string, ...segments: Array<Segment>) => {
    const tagId = [id, ...(segments ?? [])].filter(isValidSegment).join("-");

    return {
        [TAG_ID]: tagId
    };
};

const getTagZoneIdFor = (id: string, ...segments: Array<Segment>) => {
    const tagZoneId = ["zone", id, ...(segments ?? [])]
        .filter(isValidSegment)
        .join("-");

    return {
        [TAG_ZONE_ID]: tagZoneId
    };
};

export { getTagIdFor, getTagZoneIdFor };
